import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TinymedicPatientOrderFile from './tinymedic-patient-order-file';
import TinymedicPatientOrderFileDetail from './tinymedic-patient-order-file-detail';
import TinymedicPatientOrderFileUpdate from './tinymedic-patient-order-file-update';
import TinymedicPatientOrderFileDeleteDialog from './tinymedic-patient-order-file-delete-dialog';

const TinymedicPatientOrderFileRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TinymedicPatientOrderFile />} />
    <Route path="new" element={<TinymedicPatientOrderFileUpdate />} />
    <Route path=":id">
      <Route index element={<TinymedicPatientOrderFileDetail />} />
      <Route path="edit" element={<TinymedicPatientOrderFileUpdate />} />
      <Route path="delete" element={<TinymedicPatientOrderFileDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TinymedicPatientOrderFileRoutes;
